import type { TimePickerProps } from "@components/contracts/TimePicker.types";
import type React from "react";
import { TimePicker as RsTimePicker } from "rsuite";

import "./TimePicker.component.scss";

export const RsuiteTimePicker: React.FC<TimePickerProps> = ({
  id,
  label,
  onChange,
  ...props
}) => (
  <div style={{ width: "100%" }}>
    {label && (
      <label htmlFor={id} className="input-label input-label--lg">
        {label}
      </label>
    )}

    <RsTimePicker
      className="custom"
      id={id}
      block
      {...props}
      onChange={(date) => onChange?.(date)}
    />
  </div>
);
